// extracted by mini-css-extract-plugin
export var black = "_2p-6";
export var brand = "_2p-1";
export var ddefault = "_2p-0";
export var error = "_2p-3";
export var gray = "_2p-2";
export var highContrast = "_2p-8";
export var outline = "_2p-7";
export var success = "_2p-5";
export var warning = "_2p-4";